export function capitalizeFirstLetter(str?: string) {
  return (
    str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ") || ""
  );
}

export function formatCurrency(
  value: number | undefined | null,
  currency?: string,
  display?: "code" | "symbol"
) {
  try {
    if (value != null) {
      return value.toLocaleString("en-NG", {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        currencyDisplay: display || undefined,
      });
    } else {
      return "amount must be 200 above and less than 5,000,000";
    }
  } catch (e) {
    return "N/A";
  }
}

export function formatDate(dateString: string) {
  const options: Intl.DateTimeFormatOptions = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  };

  return new Date(dateString)
    .toLocaleDateString(undefined, options)
    .replace(/\//g, "/");
}

export function formatDateLong(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const formattedDate = date.toLocaleString("en-US", options).toUpperCase();
  return formattedDate.replace(",", "");
}

export function signOut() {
  localStorage.removeItem("token");
  // localStorage.removeItem("profilePhoto");
  // localStorage.removeItem("user");
  // localStorage.removeItem("userEmail");
  // localStorage.removeItem("showAccountSetupWarning");
}

export function truncateEmail(email: string, maxLength = 15) {
  if (!email) return "";
  if (email.length <= maxLength) return email;
  const truncated = email.substring(0, maxLength) + "...";
  return truncated;
}

export function isLoggedIn() {
  const token = localStorage.getItem("token");
  return token != null;
}

export function maskEmail(email: string | null): string {
  if (!email) return "";
  const [name, domain] = email.split("@");
  if (name.length > 4) {
    return `${name.slice(0, 3)}${"*".repeat(name.length - 4)}${
      name[name.length - 1]
    }@${domain}`;
  }
  return email;
}

export function getRoleColor(status: string) {
  switch (status) {
    case "superAdmin":
      return "#FFF1F2";
    case "Inventory":
      return "#FFFBEB";
    case "sales-manager":
      return "#F0FDF4";
    case "inventory-manager":
      return "#FFFBEB";
    case "admin":
      return "#FFFBEB";
    default:
      return "transparent";
  }
}

export function getRoleTextColor(status: string) {
  switch (status) {
    case "superAdmin":
      return "#F43F5E";
    case "Inventory":
      return "#F59E0B";
    case "sales-manager":
      return "#22C55E";
    case "inventory-manager":
      return "#F59E0B";
    case "sourcing-officer":
      return "#F59E0B";
    case "admin":
      return "#F59E0B";
    default:
      return "transparent";
  }
}

export function getTypeColor(status: string) {
  switch (status) {
    case "b2b":
      return "#FAFEEF";
    case "b2c":
      return "#FFF2DC";
    default:
      return "transparent";
  }
}

export function getTypeTextColor(status: string) {
  switch (status) {
    case "b2b":
      return "#86B400";
    case "b2c":
      return "#FFA200";
    default:
      return "transparent";
  }
}

export function getPermissionColor(status: string) {
  switch (status) {
    case "all":
      return "#FFF1F2";
    case "sales":
      return "#F0FDF4";
    case "inventory":
      return "#FFFBEB";
    case "suppliers":
      return "#F0FDF4";
    case "users":
      return "#F0FDF4";
    case "customers":
      return "#F0FDF4";
    default:
      return "transparent";
  }
}

export function getPermissionTextColor(status: string) {
  switch (status) {
    case "all":
      return "#F43F5E";
    case "sales":
      return "#22C55E";
    case "suppliers":
      return "#22C55E";
    case "inventory":
      return "#F59E0B";
    case "users":
      return "#22C55E";
    case "customers":
      return "#22C55E";
    default:
      return "transparent";
  }
}

export function getStatusColor(status: string) {
  switch (status) {
    case "pending":
      return "#FFFBEB";
    case "approved":
      return "#F0FDF4";
    case "paid":
      return "#F0FDF4";
    case "rejected":
      return "#FDA4AF";
    case "unpaid":
      return "#FDA4AF";

    default:
      return "transparent";
  }
}

export function getStatusTextColor(status: string) {
  switch (status) {
    case "pending":
      return "#D97706";
    case "approved":
      return "#16A34A";
    case "paid":
      return "#16A34A";
    case "rejected":
      return "#E11D48";
    case "unpaid":
      return "#E11D48";
    case "upcoming":
      return "#9AC12A";
    case "shipped":
      return "#9AC12A";
    default:
      return "transparent";
  }
}

export function getStatusColorDiscount(status: string) {
  switch (status) {
    case "pending":
      return "#F5F5F5";
    case "upcoming":
      return "#FAFEEF";
    case "expired":
      return "#FFF0F3";
    case "active":
      return "#F0FDF4";
    case "approved":
      return "#F0FDF4";
    case "rejected":
      return "#F0FDF4";
    case "completed":
      return "#F0FDF4";
    default:
      return "transparent";
  }
}

export function getStatusDiscountTextColor(status: string) {
  switch (status) {
    case "pending":
      return "#4E4E4E";
    case "upcoming":
      return "#9AC12A";
    case "expired":
      return "#FF617F";
    case "active":
      return "#22C55E";
    case "approved":
      return "#22C55E";
    case "completed":
      return "#22C55E";
    case "rejected":
      return "#FF617F";

    default:
      return "transparent";
  }
}

export function getStatusRequisitionTextColor(status: string) {
  switch (status) {
    case "medium":
      return "#4E4E4E";
    case "low":
      return "#9AC12A";
    case "high":
      return "#FF617F";

    default:
      return "transparent";
  }
}

export function getStatusColorRequisition(status: string) {
  switch (status) {
    case "medium":
      return "#F0FDF4";
    case "low":
      return "";
    case "high":
      return "#FFA200";
    default:
      return "transparent";
  }
}

export function getStatusIcon(status: string) {
  switch (status) {
    case "superAdmin":
      return "paidstatusicon";

    //     case "confirmed":
    //       return "confirmedIcon";

    default:
      return "paidstatusicon";
  }
}

export function formatRelativeTime(createdAt: string): string {
  const createdTime = new Date(createdAt);
  const now = new Date();
  const diffInSeconds = Math.floor(
    (now.getTime() - createdTime.getTime()) / 1000
  );

  if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours}h ago`;
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return `${diffInDays}d ago`;
  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) return `${diffInWeeks}w ago`;
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) return `${diffInMonths}mo ago`;
  const diffInYears = Math.floor(diffInDays / 365);
  return `${diffInYears}y ago`;
}
